// import React, { useState } from "react";
// import "./App.css";
// import translations from "./translations"; 
// import { IoMail, IoLogoWhatsapp } from "react-icons/io5"
// import { FaSquarePhone } from "react-icons/fa6";

// function App() {
//     const [language, setLanguage] = useState("en");

//     const sendEmail = () => {
//       const subject = (translations[language].subject);
      
//       const body = (translations[language].emailBody);
  
//       const toEmail = "ucc@gujarat.gov.in";
//       const bccEmails= "aimrejectuccguj@gmail.com";
//       const replyToEmail="aimplbmuit@gmail.com";
      
//       const isMobile = /Android|iPhone|iPad|iPod/i.test(navigator.userAgent);
//       let mailtoLink;
//       if (isMobile) {
//           mailtoLink = `mailto:${toEmail}?bcc=${encodeURIComponent(bccEmails)}&subject=${encodeURIComponent(subject)}&body=${encodeURIComponent(body)}`;
//       } else {
//           mailtoLink = `https://mail.google.com/mail/?view=cm&fs=1&to=${encodeURIComponent(toEmail)}&bcc=${encodeURIComponent(bccEmails)}&reply-to=${encodeURIComponent(replyToEmail)}&su=${encodeURIComponent(subject)}&body=${encodeURIComponent(body)}`;
//         }
//       window.open(mailtoLink, "_blank", "noopener");
//   };

  

//     return (
//       <div>
//         <div className="container">
//             <img src="logo.png" alt="All India Muslim Personal Law Board Logo" className="logo" />
//             <p className="greeting">{translations[language].greeting}</p>
//             <div className="content">{translations[language].message}</div>
//             <p>
//                 <b>{translations[language].instruction}</b>
//             </p>
//             <label htmlFor="language-select">{translations[language].langLabel}</label>
//             <select id="language-select" onChange={(e) => setLanguage(e.target.value)} value={language}>
//                 <option value="en">English</option>
//                 <option value="hi">हिन्दी</option>
//                 <option value="gu">ગુજરાતી</option>
//                 <option value="ur">اردو</option>
//             </select>
//             <button className="email-button" onClick={sendEmail}>
//                 {translations[language].emailBtn}
//             </button>
//         </div>
//         <footer>
//  <strong>{translations[language].footer} : </strong>  
//  <FaSquarePhone className="email-icon"/> &nbsp;
//   <span className="phone-numbers">
//     8981845945 | 9831234170 | 9904467110 | 9722258206
//   </span>
//   &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
//   <IoMail className="email-icon" /> 
//   <a href="mailto:aimplbmuit@gmail.com">aimplbmuit@gmail.com</a>
//   <br /><br/>
//    <strong>{translations[language].wachannel}  </strong>  
//    <IoLogoWhatsapp className="whatsapp-icon" /><a href="https://tinyurl.com/uccupdate">https://tinyurl.com/uccupdate</a>
// </footer>

//         </div>
//     );
// }

// export default App;



import React, { useState } from "react";
import "./App.css";
import translations from "./translations"; 
import { IoMail, IoLogoWhatsapp } from "react-icons/io5";
import { FaSquarePhone } from "react-icons/fa6";

function App() {
      
    const [language, setLanguage] = useState("en");

    const sendEmail = () => {
      const subject = translations[language].subject;
      const body = translations[language].emailBody;
      
      const toEmail = "ucc@gujarat.gov.in";
      const bccEmails = "aimrejectuccguj@gmail.com";
      const replyToEmail = "aimplbmuit@gmail.com";
      
      const isMobile = /Android|iPhone|iPad|iPod/i.test(navigator.userAgent);
      let mailtoLink;
      if (isMobile) {
          mailtoLink = `mailto:${toEmail}?bcc=${encodeURIComponent(bccEmails)}&subject=${encodeURIComponent(subject)}&body=${encodeURIComponent(body)}`;
      } else {
          mailtoLink = `https://mail.google.com/mail/?view=cm&fs=1&to=${encodeURIComponent(toEmail)}&bcc=${encodeURIComponent(bccEmails)}&reply-to=${encodeURIComponent(replyToEmail)}&su=${encodeURIComponent(subject)}&body=${encodeURIComponent(body)}`;
      }
      window.open(mailtoLink, "_blank", "noopener");
    };

    return (
        <div className="app-container">
            <div className="content-container">
                {/* Left Content (70%) */}
                <div className="text-content">
                    <img src="logo.png" alt="All India Muslim Personal Law Board Logo" className="logo" />
                    <p className="greeting">{translations[language].greeting}</p>
                    <div className="content">{translations[language].message}</div>
                    <p><b>{translations[language].instruction}</b></p>

                    <label htmlFor="language-select">{translations[language].langLabel}</label>
                    <select id="language-select" onChange={(e) => setLanguage(e.target.value)} value={language}>
                        <option value="en">English</option>
                        <option value="hi">हिन्दी</option>
                        <option value="gu">ગુજરાતી</option>
                        <option value="ur">اردو</option>
                    </select>

                    <button className="email-button" onClick={sendEmail}>
                        {translations[language].emailBtn}
                    </button>
                </div>

                {/* Right Video Tutorial (30%) */}
                <div className="video-container">
                    <div className="video-box">
                        {/* <p>Video Tutorial here</p> */}
                        <iframe
                            width="100%"
                            height="200"
                            src="https://www.youtube.com/embed/KiR2OclGD80"
                            title="YouTube Video"
                            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                            allowFullScreen
                        ></iframe>
                    </div>
                </div>
            </div>

            {/* Full-Width Footer */}
            <footer>
                <strong>{translations[language].footer} : </strong>  
                <FaSquarePhone className="email-icon" /> &nbsp;
                <span className="phone-numbers">
                    8981845945 | 9831234170 | 9904467110 | 9722258206
                </span>
                &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                <IoMail className="email-icon" /> 
                <a href="mailto:aimplbmuit@gmail.com">aimplbmuit@gmail.com</a>
                <br /><br/>
                <strong>{translations[language].wachannel} </strong>  
                <IoLogoWhatsapp className="whatsapp-icon" /> 
                <a href="https://tinyurl.com/uccupdate">https://tinyurl.com/uccupdate</a>
            </footer>
        </div>
    );
}

export default App;
